import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { Notification } from 'Components/frameworks/notification/Notification';
type Props = {
  className?: string;
  onClose?: () => unknown;
  text?: string;
  title?: string;
  type?: 'error' | 'success';
};
export const Alert = ({ type, ...rest }: Props) => {
  let props;

  switch (type) {
    case 'success': {
      props = {
        className: 'text-success',
        iconName: ICONS.CHECK_OUTLINE,
      };
      break;
    }

    default: {
      props = {
        className: 'text-red',
        iconName: ICONS.WARNING,
      };
    }
  }

  return <Notification {...rest} {...props} hasClose />;
};
